module.exports = __webpack_public_path__ + "static/1-d19cf6a620b29d152b35a9146bff58dd.png";